


































import { Component, Vue } from 'vue-property-decorator';
import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';
import { MDAAccountService } from '@/api/com/MetaPattern/APP/MDA/User/MDAAccountService';
import { AccountInfoDTO } from '@/api/com/MetaPattern/APP/MDA/User/AccountInfoDTO';
import { EnumStorageType, StorageLib } from '@/libs/com/MetaPattern/Product/IDE/Util/StorageLib';
import { MDAConstant } from '@/libs/com/MetaPattern/MDA/Designer/Base/MDAConstant';
@Component({
  components: {
  }
})
export default class Login extends Vue {
  private loginName: string;
  private password: string;
  private errorMessage: string;

  constructor() {
    super();
    this.loginName = 'myth1979';
    this.password = '123456';
    this.errorMessage = '';
  }

  get context(): IDEContext {
    return IDEContext.instance;
  }

  login() {
    MDAAccountService.LoginByPasswordAsync(this.loginName, this.password)
      .then((response: AccountInfoDTO) => {
        if (response !== null) {
          StorageLib.instance.setItem(EnumStorageType.Expiration, MDAConstant.Account.SATOKEN, response.token, MDAConstant.Account.LOGIN_TIMEOUT);
          IDEContext.instance.setCurAccountInfoAsync(response)
            .then(() => {
              if (IDEContext.instance.users.length >= 1) {
                this.$router.push('/UserSelect');
              } else {
                // TODO : 没有用户信息，不能登录
                this.errorMessage = '登录失败，请重试';
              }
            });
        } else {
          this.errorMessage = '登录失败，请重试';
        }
      })
      .catch(error => {
        this.errorMessage = error;
      });
  }

  goRegist() {
    this.$router.push('/Regist');
  }
}
